<template>
  <div
    tabindex="0"
    class="tw-cursor-pointer tw-block tw-border tw-border-gray dark:tw-border-dm-gray tw-rounded-3xl tw-p-6 tw-transition hover:tw-shadow"
    @click="$emit('open-detail')"
  >
    <div class="tw-flex tw-justify-between tw-items-center">
      <div class="tw-w-full">
        <h3 class="tw-leading-6 tw-tracking-wide tw-mb-2">
          {{ permit.permit_type_name }}
        </h3>

        <div
          class="tw-inline-flex tw-items-center tw-text-xs tw-leading-[14px] tw-text-gray-dark dark:tw-text-dm-gray-dark"
        >
          <div class="tw-inline-flex tw-items-center tw-mr-3">
            <icon-star
              v-if="permit.is_main"
              class="tw-w-4 tw-h-4 tw-text-primary dark:tw-text-dm-primary tw-mr-1"
            />
            <span class="">
              {{ permit.reference_number }}
            </span>
          </div>
          <span>
            {{ permit.issue_date }}
            &ndash;
            {{ permit.expire_date }}
          </span>
        </div>
      </div>
      <div v-if="permit.final_document_url">
        <i-button
          type="primary"
          size="medium"
          is-icon
          @click.stop="downloadFileByUrlV2(permit.final_document_url, 'obtained_document.pdf', $axios)"
        >
          <icon-download />
        </i-button>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadFileByUrlV2 } from '@/helpers';

export default {
  name: 'PermitBoxObtained',
  props: {
    permit: {
      type: Object,
      required: true,
    },
  },

  methods: {
    downloadFileByUrlV2,
  },
};
</script>
